export const MODAL_LOGIN = 'login'
export const MODAL_LOADING = 'loading'
export const MODAL_REPORT = 'report'
